var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_5591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.28968 18.128C13.837 18.128 17.965 11.8752 17.965 6.45279C17.965 6.27519 17.965 6.09839 17.953 5.92239C18.7561 5.34152 19.4493 4.6223 20.0003 3.79839C19.2514 4.13024 18.4569 4.34786 17.6434 4.44399C18.5 3.93118 19.1411 3.12461 19.4475 2.17439C18.642 2.65236 17.7607 2.9892 16.8418 3.17039C16.2231 2.51254 15.4049 2.07693 14.5137 1.93096C13.6225 1.785 12.708 1.93682 11.9118 2.36294C11.1156 2.78905 10.482 3.4657 10.1091 4.28818C9.73618 5.11066 9.64474 6.03311 9.84893 6.91279C8.21751 6.83101 6.62152 6.40706 5.16458 5.66847C3.70763 4.92987 2.4223 3.89315 1.39202 2.62559C0.867285 3.52892 0.70657 4.59828 0.942595 5.61595C1.17862 6.63361 1.79364 7.52306 2.66243 8.10319C2.00942 8.08384 1.37064 7.90768 0.80001 7.58959C0.80001 7.60639 0.80001 7.62399 0.80001 7.64159C0.80027 8.58897 1.12822 9.50709 1.72825 10.2402C2.32827 10.9734 3.16343 11.4764 4.09205 11.664C3.48794 11.8287 2.8541 11.8528 2.23923 11.7344C2.50144 12.5497 3.01193 13.2627 3.6993 13.7737C4.38668 14.2846 5.21656 14.5679 6.07288 14.584C4.61985 15.7259 2.82488 16.3459 0.976813 16.344C0.650331 16.3434 0.324167 16.3236 0 16.2848C1.87653 17.489 4.05998 18.1278 6.28968 18.1248",
    fill: "#1DA1F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_5591"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.0003,
    height: 20,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/TwitterLogo.172b09ee2dfa9fdae8729b94f007e0da.svg";
export { ForwardRef as ReactComponent };